import { root } from '../../../../../../store/constants';
import { TCardId } from '../../../../../../types/types';

export const showTimeTrackerActions = (options?: {targetCardId: TCardId}) => {
    return () => {
        root.App.controller.showTimeTrackerActionsView(options);
    }
}
